<template>
  <div>
    <div class="d-block d-sm-flex justify-content-between">
      <h2 class="article-title">Kategóriák</h2>
      <div class="d-flex">
        <div class="form-group pr-3">
          <input type="search" class="form-control" placeholder="Keresés" v-model="filter" v-on:keyup.enter="onFilter" v-on:search="onFilter">
        </div>
        <div>
          <button type="button" class="btn btn-primary" v-on:click="onFilter">Keresés</button>
        </div>
      </div>
    </div>
    <div class="accordion" id="accordion">
      <div class="card rounded-0" v-for="item in content" :key="item.id">
        <div class="card-header cursor-pointer" :id="'heading' + item.id" data-toggle="collapse" :data-target="'#collapse' + item.id" aria-expanded="false" :aria-controls="'#collapse' + item.id">
          <div class="d-flex align-items-center">
            <span class="flex-fill">
              {{ item.name }}
            </span>
            <div class="bg-primary text-white p-1 info-count">
              {{ item.problems.length }}
            </div>
          </div>
        </div>

        <div :id="'collapse' + item.id" class="collapse" :aria-labelledby="'heading' + item.id" data-parent="#accordion">
          <div class="card-body">
            <div class="py-1 px-5" v-for="row in item.problems" :key="row.id">
              <router-link :to="'/problems/' + row.id + '/offers'">{{ row.description }}</router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'Home',
  methods: {
    onFilter: function() {
      this.content = this.list.map(row => {
         return {
            ...row,
            problems: row.problems.filter(problem =>
              this.filter
                .toLocaleLowerCase()
                .split(" ")
                .reduce(
                  (acc, filter) =>
                    acc || problem.description.toLocaleLowerCase().indexOf(filter) > -1,
                  false
                )
            )
          };
      }).filter(row => row.problems.length > 0);
    }
  },
  data() {
    return {
        list: null,
        content: null,
        filter: ''
    };
  },
  mounted() {
    axios
        .get(`https://admin2.ivsz.httpf.hu/api/categories/problems`)
        .then(response => {
          this.list = response.data;
          this.content = response.data;
        })
  }
}
</script>

<style scoped>
  .cursor-pointer {
    cursor: pointer;
  }
  .card-header {
    background-color: #f8f8f8;
  }
  .info-count {
    width: 60px;
    min-width: 60px;
    text-align: center;
    font-size: 1.1rem;
  }
</style>